import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 43301 43301"
    {...props}
  >
    <path
      d="M43300 21650c-21095 39-21099 76-440 4363-20673-4215-20685-4180-1262 4065-19450-8179-19467-8147-1995 3677-17512-11765-17535-11737-2644 3204-14941-14891-14969-14869-3204 2644-11824-17472-11855-17455-3677 1995-8245-19422-8280-19411-4065 1262-4287-20659-4324-20655-4363 440-38-21095-75-21099-4362-440 4215-20673 4180-20684-4065-1262 8178-19451 8147-19468-3677-1995 11764-17513 11737-17535-3204-2644 14891-14941 14868-14969-2644-3204 17472-11824 17455-11855-1995-3677 19422-8245 19411-8280-1262-4065 20659-4287 20655-4324-440-4363 21095-38 21099-75 440-4362 20673 4215 20684 4180 1262-4065 19451 8178 19468 8147 1995-3677 17512 11764 17535 11737 2644-3204 14941 14891 14969 14868 3204-2644 11824 17472 11855 17455 3677-1995 8245 19422 8280 19411 4065-1262 4287 20659 4324 20655 4362-440 39 21095 76 21099 4363 440-4215 20673-4180 20684 4065 1262-8179 19450-8147 19467 3677 1995-11765 17512-11737 17535 3204 2644-14891 14941-14868 14968 2644 3204-17472 11824-17455 11855 1995 3677-19422 8245-19411 8280 1262 4065-20659 4287-20655 4324 440 4362z"
      style={{
        fill: "#1c1b17",
        stroke: "#1c1b17",
        strokeWidth: 1273.48,
      }}
      className="stroke1 fill"

    />
  </svg>
)
export default SvgComponent
